import { render, staticRenderFns } from "./PlansSection.vue?vue&type=template&id=0e46d34b&scoped=true"
import script from "./PlansSection.vue?vue&type=script&lang=js"
export * from "./PlansSection.vue?vue&type=script&lang=js"
import style0 from "./PlansSection.vue?vue&type=style&index=0&id=0e46d34b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e46d34b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e46d34b')) {
      api.createRecord('0e46d34b', component.options)
    } else {
      api.reload('0e46d34b', component.options)
    }
    module.hot.accept("./PlansSection.vue?vue&type=template&id=0e46d34b&scoped=true", function () {
      api.rerender('0e46d34b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/Plans/PlansSection.vue"
export default component.exports